import Request from './Request';

export interface IMonth {
    id: number;
    name: string;
    order: number;
}

class Month {
    static GetAll = (): IMonth[] => { return Request.DoGet('month/all') as unknown as IMonth[]; };
    static Get = (id: Number): IMonth => { return Request.DoGet('month/' + id) as unknown as IMonth; };
}

export default Month;